import { render, staticRenderFns } from "./BgpEndpointList.vue?vue&type=template&id=07c49f99&"
import script from "./BgpEndpointList.vue?vue&type=script&lang=js&"
export * from "./BgpEndpointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports